import merge from 'lodash/merge';
import { IApiInteraction } from '../models/interactions/interaction.types';
import { IApiMatch } from '../models/match';
import { IApiLastConnection, IApiMember } from '../models/member/member.types';
import {
  IApiPhotoPrivacyIncludedArray,
  IApiPhotoRequest,
} from '../models/photoRequests';
import { IApiPhotoRevealStatus } from '../models/photoRequests/photoRequests.types';
import { IApiPhotoReveal } from '../models/photoReveals/photoReveals.types';
import { IApiThread } from '../models/thread';

export const extractRelationshipsFromDataByMemberId = (
  data: Array<IApiMatch | IApiInteraction | IApiThread>,
  keyMember: string,
  id: string
) => {
  return data.find(
    ({ relationships }) => relationships[keyMember].data.id === id
  );
};

export const extractPhotoRevealStatus = (
  included: IApiPhotoPrivacyIncludedArray,
  photoPrivacyData:
    | IApiPhotoReveal
    | IApiPhotoRequest
    | IApiInteraction
    | IApiMatch
    | IApiThread
    | undefined
): {
  photoRevealStatus?: string | null;
} => {
  if (!(photoPrivacyData && photoPrivacyData.relationships.photoRevealStatus)) {
    return {};
  }

  const revealStatusId =
    photoPrivacyData.relationships.photoRevealStatus.data.id;

  const revealStatus = included.find(
    ({ id, type }: { id: string; type: string }) =>
      type === 'photoRevealStatus' && id === revealStatusId
  ) as IApiPhotoRevealStatus;

  return {
    photoRevealStatus: revealStatus ? revealStatus.attributes.value : null,
  };
};

export const extractLastConnection = (
  included: IApiPhotoPrivacyIncludedArray,
  privacyData:
    | IApiPhotoReveal
    | IApiPhotoRequest
    | IApiInteraction
    | IApiMatch
    | IApiThread
    | undefined
): {
  lastConnectionDate?: string | null;
} => {
  if (!(privacyData && privacyData.relationships.lastConnection) || !included) {
    return {};
  }

  const lastConnectionId = privacyData.relationships.lastConnection.data.id;

  const connectionStatus = included.find(
    ({ id, type }: { id: string; type: string }) =>
      type === 'lastConnection' && id === lastConnectionId
  ) as IApiLastConnection;

  return {
    lastConnectionDate: connectionStatus
      ? connectionStatus.attributes.last_connection_date
      : null,
  };
};

export const memberSerializer = (coreSerializer: any) => (
  member: IApiMember,
  api: any
) => {
  const coreMember = coreSerializer(member, api);
  const keyMember = Object.keys(api.data[0].relationships).find(
    key => api.data[0].relationships[key].data.type === 'member'
  );
  const relationships =
    keyMember &&
    extractRelationshipsFromDataByMemberId(api.data, keyMember, member.id);

  return relationships
    ? merge(coreMember, {
        profile: {
          ...extractPhotoRevealStatus(api.included, relationships),
          ...extractLastConnection(api.included, relationships),
        },
      })
    : coreMember;
};
